import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import { ref, get, set, child, push, query, orderByChild, equalTo, startAt } from 'firebase/database'
import { signInWithEmailAndPassword, signOut, updatePassword, reauthenticateWithCredential, EmailAuthProvider } from 'firebase/auth'
import { auth, db, dbRef, turnos, usuarios, mecanicos, tiposTurno, estadosTurno, horariosTurno, refTurnos } from '../firebase'
import { parseDate } from '../utils'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    hora: null,
    lunes: null,
    martes: null,
    miercoles: null,
    jueves:  null,
    viernes: null,
    sabado: null,
    actual: null,
    user: {},
    calendario: [],
    horarios: [],
    entregas3: [],
    entregas: [],
    postventa: [],
    mecanicos: [],
    tipos_turno: [],
    estados_turno: [],
    horarios_turno: null
  },
  mutations: {
    set_user (state, payload) {
      state.user = payload
      localStorage.setItem('user', JSON.stringify(payload))
    },
    set_mecanicos (state, payload) {
      state.mecanicos = payload
      localStorage.setItem('mecanicos', JSON.stringify(payload))
    },
    set_tipos_turno (state, payload) {
      state.tipos_turno = payload
      localStorage.setItem('tipos_turno', JSON.stringify(payload))
    },
    set_estados_turno (state, payload) {
      state.estados_turno = payload
      localStorage.setItem('estados_turno', JSON.stringify(payload))
    },
    set_horarios_turno (state, payload) {
      state.horarios_turno = payload
      localStorage.setItem('horarios_turno', JSON.stringify(payload))
    }
  },
  actions: {
    // ----------------------------------
    //            TURNOS
    // ----------------------------------
    async turnos_tv ({ state }, payload) {
      try {
        const fecha = moment(new Date()).format('DD/MM/YYYY')
        let entregas = []
        state.postventa = []
        state.entregas = []
        state.calendario = []
        state.horarios = []
        state.entregas3 = []

        for (const key in payload) {
          if (Object.hasOwnProperty.call(payload, key)) {
            // obtiene la informacion del item con id = key
            const element = payload[key]
            let turno = element
            turno.id = key
            // solo agrega el turno si está activo
            if (turno.activo == 1) {
              // agrega el turno en el array correspondiente
              if (turno.tipo == 'POSTVENTA' && turno.fecha == fecha) {
                
                // formatea la duracion de minutos a hotas
                //turno.duracion = `${(turno.duracion / 60).toFixed()}:${(turno.duracion % 60).toFixed().padStart(2, 0)} Hs.`
                state.postventa.push(turno)

              } else if (turno.tipo == 'ENTREGA') {

                // formatea el texto para la card del calendario
                let asesor = ''
                if (turno.asesor) {
                  asesor = ' - ' + turno.asesor
                }
                turno.texto = turno.cliente + ' - ' + turno.vehiculo + asesor
                turno.dia = moment(parseDate(turno.fecha)).format('DD')

                // agrega el truno a los array
                entregas.push(turno)
                state.entregas.push({
                  name: turno.cliente + ' - ' + turno.vehiculo + asesor,
                  start: parseDate(turno.fecha) + ' ' + turno.hora,
                  end: moment(parseDate(turno.fecha) + ' ' + turno.hora).add(1.5, 'hour').format('YYYY-MM-DD HH:mm')
                })
                if (turno.fecha == fecha) {
                  state.entregas3.push(turno) 
                }
              }
            }
          }
        }

        // ordena las entregas por hora
        entregas.sort(function(a, b) {
          if(a.hora < b.hora) { return -1 }
          if(a.hora > b.hora) { return 1 }
          return 0
        })
        // agrupa a las entregas por hora
        let group_by_hora = entregas.reduce(function (r, a) {
          r[a.hora] = r[a.hora] || []
          r[a.hora].push(a)
          return r
        }, Object.create(null))
        // cicla por cada grupo de entregas con la misma hora
        for (const key in group_by_hora) {
          // agrega los turnos al array de calendario y la hora al array de horarios
          state.calendario.push(group_by_hora[key])
          state.horarios.push(key)
        }

        // ordena los turnos por hora
        state.postventa.sort(function(a, b) {
          if(a.hora < b.hora) { return -1 }
          if(a.hora > b.hora) { return 1 }
          return 0
        })

        // ordena los turnos por hora
        state.entregas.sort(function(a, b) {
          if(a.hora < b.hora) { return -1 }
          if(a.hora > b.hora) { return 1 }
          return 0
        })


      } catch (error) {
        console.log(error)
      }
    },
    async get_turnos ({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          const tipo = payload.tipo
          const estado = payload.estado
          const cliente = payload.cliente
          const fecha_desde = + new Date(parseDate(payload.fecha_desde))
          const fecha_hasta = + new Date(parseDate(payload.fecha_hasta))
          const activo = payload.activo

          let req = query(refTurnos, orderByChild('timestamp'), startAt(fecha_desde))
          // si borró la fecha desde entonces filtra por los activos
          if (!fecha_desde) {
            req = query(refTurnos, orderByChild('activo'), equalTo(activo))
          }

          await get(req)
          .then((snapshot) => {
            let turnos = []
            if (snapshot.exists()) {
              const data = snapshot.val()
              // recorre la data para formatearla
              for (const key in data) {
                if (Object.hasOwnProperty.call(data, key)) {
                  // obtiene la informacion del item con id = key
                  const element = data[key]
                  let turno = element
                  turno.id = key

                  // aplica los otros filtros
                  let f_tipo = true
                  let f_estado = true
                  let f_cliente = true
                  let f_fecha_hasta = true
                  let f_activo = turno.activo == activo

                  if (tipo) f_tipo = turno.tipo == tipo
                  if (estado) f_estado = turno.estado == estado
                  if (cliente) f_cliente = turno.cliente.indexOf(cliente) >= 0
                  if (fecha_hasta) f_fecha_hasta = turno.timestamp <= fecha_hasta

                  if (f_tipo && f_estado && f_cliente && f_fecha_hasta && f_activo) {
                    // agrega el turno al array
                    turnos.push(turno) 
                  }
                }
              }
            }
            resolve(turnos)
          })
          .catch((error) => {
            reject(error)
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    async editar_turno ({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          // copia el paylaod en la data para quitarle el id
          let data = JSON.parse(JSON.stringify(payload))
          delete data.id
          await set(ref(db, turnos + '/' + payload.id), data)
            .then(() => {
              resolve({
                data: payload,
                message: 'Turno modificado correctamente'
              })
            })
            .catch((error) => {
              reject(error)
            })
        } catch (error) {
          reject(error)
        }
      })
    },
    async nuevo_turno ({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          // crea un nuevo id
          const newKey = push(child(dbRef, turnos)).key
          await set(ref(db, turnos + '/' + newKey), payload)
            .then(() => {
              let tunro = payload
              tunro.id = newKey
              resolve({
                data: tunro,
                message: 'Turno registrado correctamente'
              })
            })
            .catch((error) => {
              reject(error)
            })
        } catch (error) {
          reject(error)
        }
      })
    },
    // ----------------------------------
    //            GENERALES
    // ----------------------------------
    async get_mecanicos ({ commit }) {
      return await new Promise(async (resolve, reject) => {
        try {
          await get(child(dbRef, mecanicos))
            .then((snapshot) => {
              let mecanicos = []
              if (snapshot.exists()) {
                const data = snapshot.val()
                // recorre la data para formatearla
                for (const key in data) {
                  if (Object.hasOwnProperty.call(data, key)) {
                    // obtiene la informacion del item con id = key
                    const mecanico = data[key]
                    mecanicos.push(mecanico.nombre + ' ' + mecanico.apellido)
                  }
                }
              }
              commit('set_mecanicos', mecanicos)
              resolve()
            })
            .catch((error) => {
              commit('set_mecanicos', [])
              reject(error)
            })
        } catch (error) {
          commit('set_mecanicos', [])
          reject(error)
        }
      })
    },
    async get_tipos_turno ({ commit }) {
      return await new Promise(async (resolve, reject) => {
        try {
          await get(child(dbRef, tiposTurno))
            .then((snapshot) => {
              let tipos_turno = []
              if (snapshot.exists()) {
                const data = snapshot.val()
                // recorre la data para formatearla
                for (const key in data) {
                  if (Object.hasOwnProperty.call(data, key)) {
                    // obtiene la informacion del item con id = key
                    const tipo = data[key]
                    tipos_turno.push(tipo.nombre)
                  }
                }
              }
              commit('set_tipos_turno', tipos_turno)
              resolve()
            })
            .catch((error) => {
              commit('set_tipos_turno', [])
              reject(error)
            })
        } catch (error) {
          commit('set_tipos_turno', [])
          reject(error)
        }
      })
    },
    async get_estados_turno ({ commit }) {
      return await new Promise(async (resolve, reject) => {
        try {
          await get(child(dbRef, estadosTurno))
            .then((snapshot) => {
              let estados_turno = []
              if (snapshot.exists()) {
                const data = snapshot.val()
                // recorre la data para formatearla
                for (const key in data) {
                  if (Object.hasOwnProperty.call(data, key)) {
                    // obtiene la informacion del item con id = key
                    const estado = data[key]
                    estados_turno.push(estado)
                  }
                }
              }
              commit('set_estados_turno', estados_turno)
              resolve()
            })
            .catch((error) => {
              commit('set_estados_turno', [])
              reject(error)
            })
        } catch (error) {
          commit('set_estados_turno', [])
          reject(error)
        }
      })
    },
    async get_horarios_turno ({ commit }) {
      return await new Promise(async (resolve, reject) => {
        try {
          await get(child(dbRef, horariosTurno))
            .then((snapshot) => {
              let horarios_turno = {}
              if (snapshot.exists()) {
                const data = snapshot.val()
                horarios_turno = data
              }
              commit('set_horarios_turno', horarios_turno)
              resolve()
            })
            .catch((error) => {
              commit('set_horarios_turno', null)
              reject(error)
            })
        } catch (error) {
          commit('set_horarios_turno', null)
          reject(error)
        }
      })
    },
    async cambiar_pass ({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          const user = auth.currentUser
          const credential = EmailAuthProvider.credential(
            user.email,
            payload.pass_actual
          )
          reauthenticateWithCredential(user, credential)
            .then(() => {
              // User re-authenticated.
              updatePassword(user, payload.pass_nueva)
                .then(() => {
                  // Update successful.
                  resolve('Contraseña actualizada correctamente')
                })
                .catch((error) => {
                  // An error ocurred
                  switch (error.code) {
                    case 'auth/too-many-requests':
                      reject('Se ha superado el límite de intentos de cambio de contraseña, intente más tarde')
                      break
                    default:
                      reject(error.code)
                      break
                  }
                })
            })
            .catch((error) => {
              switch (error.code) {             
                case 'auth/wrong-password':
                  reject('Contraseña actual incorrecta')
                  break
                case 'auth/too-many-requests':
                  reject('Se ha superado el límite de intentos de cambio de contraseña, intente más tarde')
                  break
                default:
                  reject(error.code)
                  break
              }
            })
        } catch (error) {
          reject(error)
        }
      })
    },
    async login ({ commit }, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          await signInWithEmailAndPassword(auth, payload.email, payload.password)
            .then(async (userCredential) => {
              // Signed in
              const user = userCredential.user
              // obtiene los datos del usuario
              await get(child(dbRef, usuarios + '/' + user.uid))
                .then((snapshot) => {
                  if (snapshot.exists()) {
                    const data = snapshot.val()
                    // guarda el usuario en el local storage
                    commit('set_user', {
                      nombre: data.nombre,
                      apellido: data.apellido
                    })
                  }
                  resolve()
                })
                .catch((error) => {
                  reject(error)
                })
            })
            .catch((error) => {
              switch (error.code) {
                case 'auth/user-not-found':
                  reject('Usuario o contraseña incorrectos')
                  break
                case 'auth/wrong-password':
                  reject('Usuario o contraseña incorrectos')
                  break
                case 'auth/too-many-requests':
                  reject('Se ha superado el límite de intentos de inicio de sesión, intente más tarde')
                  break
                default:
                  reject(error)
                  break;
              }
            }) 
        } catch (error) {
          reject(error)
        }
      })
    },
    async logout ({ commit }) {
      return await new Promise(async (resolve, reject) => {
        try {
          await signOut(auth)
            .then(async () => {
              // borra el usuario del local storage (el guard del router se encarga de redirigir al login)
              commit('set_user', {})
              commit('set_mecanicos', [])
              commit('set_tipos_turno', [])
              commit('set_estados_turno', [])
              commit('set_horarios_turno', null)
              resolve()
            })
            .catch((error) => {
              reject(error)
            }) 
        } catch (error) {
          reject(error)
        }
      })
    },
    loadLocalStorage({ commit, state }) {
      /**
       * para evitar errores en caso de que se borre el local storage, si no lo encuentra
       * carga por defecto la variable correspondiente definida en el state. Solo en el caso
       * que la varibale sea null en el state se peude utilizar el setItem sin el if
       */
      // usuario
      if (localStorage.getItem('user')) commit('set_user', JSON.parse(localStorage.getItem('user')))
      else localStorage.setItem('user', JSON.stringify(state.user))
      // mecanicos
      if (localStorage.getItem('mecanicos')) commit('set_mecanicos', JSON.parse(localStorage.getItem('mecanicos')))
      else localStorage.setItem('mecanicos', JSON.stringify(state.mecanicos))
      // tipos de turnos
      if (localStorage.getItem('tipos_turno')) commit('set_tipos_turno', JSON.parse(localStorage.getItem('tipos_turno')))
      else localStorage.setItem('tipos_turno', JSON.stringify(state.tipos_turno))
      // estados de los turnos
      if (localStorage.getItem('estados_turno')) commit('set_estados_turno', JSON.parse(localStorage.getItem('estados_turno')))
      else localStorage.setItem('estados_turno', JSON.stringify(state.estados_turno))
      // horarios de los turnos
      commit('set_horarios_turno', JSON.parse(localStorage.getItem('horarios_turno')))
    }
  },
  modules: {
  }
})
